import { fetchData } from "./fetch";

export const getSubaccounts = () => fetchData('GET', '/sendpost/subaccounts');

export const getDomains = (data) => fetchData('GET', '/sendpost/domains', data);
